export const authZhCN = {
  session: {
    restoring: '正在恢复会话',
    confirming: '正在确认你的登录状态，请稍候。',
    restoringInline: '正在恢复会话…',
    unavailableTitle: '暂时无法确认登录状态',
    unavailableDescription:
      '请重试；如果问题持续，可以退出当前会话后重新登录。',
  },
  fields: {
    account: '账号',
    accountPlaceholder: '用户名、邮箱或手机号',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    remember: '记住我',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    registeredEmailPlaceholder: '请输入注册邮箱',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmNewPassword: '确认新密码',
    confirmNewPasswordPlaceholder: '请再次输入新密码',
    minimum6: '至少 6 位',
    minimum8: '至少 8 位',
    showPassword: '显示密码',
    hidePassword: '隐藏密码',
  },
  validation: {
    invalidEmail: '请输入有效的邮箱地址',
    invalidPhone: '请输入有效的中国大陆手机号',
    passwordMismatch: '两次输入的密码不一致',
    minimum8: '{{field}}长度至少为 8 位',
    required: '请输入{{field}}',
  },
  login: {
    title: '欢迎登录',
    description: '使用您的账户进入 UFP 数字化教学平台',
    noAccount: '还没有账号？',
    register: '立即注册',
    forgotPassword: '忘记密码？',
    submit: '登录',
    registered: '注册成功，请登录',
    verified: '邮箱已验证，请登录',
    reset: '密码已更新，请用新密码登录',
    failed: '登录失败，请检查账号或密码',
  },
  phoneVerification: {
    title: '手机号验证',
    description: '验证手机号后，可使用手机号和密码登录。',
    phone: '手机号',
    phonePlaceholder: '请输入手机号',
    code: '验证码',
    codePlaceholder: '请输入 6 位验证码',
    requestCode: '获取验证码',
    resendCode: '重新获取',
    requesting: '发送中…',
    confirming: '验证中…',
    countdown: '{{seconds}} 秒后可重新获取',
    confirm: '验证手机号',
    verified: '手机号已验证',
    unverified: '手机号尚未验证',
    requestSuccess: '请填写短信验证码。',
    confirmSuccess: '手机号验证成功。',
    requestFailed: '验证码获取失败，请稍后重试。',
    confirmFailed: '手机号验证失败，请检查验证码。',
    invalidPhone: '请输入有效的手机号。',
    invalidCode: '请输入 6 位验证码。',
  },
  register: {
    title: '创建账号',
    emailDescription: '注册后需要验证邮箱才能登录。',
    localDescription: '注册完成后可直接登录。',
    hasAccount: '已经有账号？',
    login: '直接登录',
    emailMode: '邮箱验证',
    localMode: '快速注册',
    localHint: '快速注册立即开通账号，无需邮箱验证；正式环境建议使用邮箱验证。',
    submit: '创建账号',
    failed: '注册失败，请稍后重试',
    invalidDetails: '请检查填写的信息是否正确',
    conflict: '该用户名、邮箱或手机号已被注册',
    checkEmail: '检查你的邮箱',
    verificationSent: '验证链接已发送至 {{email}}。完成验证后即可登录。',
    created: '账号已创建，请通过邮件完成身份确认。',
    back: '返回注册',
    sending: '发送中...',
    resend: '重新发送验证邮件',
    backLogin: '返回登录',
  },
  forgot: {
    title: '忘记密码',
    description: '输入注册邮箱，我们会发送重置链接',
    submit: '发送重置链接',
    failed: '发送失败，请稍后重试',
    backLogin: '返回登录',
    sentTitle: '重置邮件已发送',
    sentDescription: '如果该邮箱存在，你将收到重置密码的邮件。',
    sentAlert: '请查收邮箱并点击邮件中的重置链接。',
  },
  reset: {
    invalidTitle: '重置链接无效',
    invalidDescription: '链接缺少访问令牌或已经失效，请重新申请。',
    requestAgain: '重新申请',
    title: '设置新密码',
    description: '创建一个至少 8 位的新密码。',
    submit: '更新密码',
    failed: '密码更新失败，请稍后重试',
    expired: '重置链接已过期，请重新申请',
  },
  verify: {
    failedTitle: '邮箱验证失败',
    invalidDescription: '验证链接无效或已过期。',
    invalidTitle: '链接无效',
    missingToken: '邮箱验证链接缺少访问令牌，请重新申请。',
    backRegister: '返回注册',
    registerAgain: '重新注册',
    backLogin: '返回登录',
    failed: '邮箱验证失败，请稍后重试',
    expired: '验证链接已过期，请重新申请',
    incomplete: '邮箱尚未完成验证，请检查邮件中的链接',
    confirmingTitle: '正在确认邮箱…',
    confirmingDescription: '请稍候，正在完成邮箱验证。',
  },
  brand: {
    platformLabel: '教育 SaaS 平台',
    defaultHeadline: '让教与学，\n都变得更聪明',
    defaultDescription:
      '课程、题库、作业与智能批改一站式管理，为学校与课程中心提供 AI 驱动的教学工作台。',
    featureChat: 'AI 对话',
    featureChatDescription: '基于课程上下文的学习助手',
    featureCourses: '课程与题库',
    featureCoursesDescription: '模板化课程、专业与题目管理',
    featureGrading: '智能批改',
    featureGradingDescription: 'AI 辅助评分与成绩一键发布',
    headline: '让教学管理更简单，让学习成长更清晰',
    featureTeaching: '一体化教学工作台',
    featureTeachingDescription: '课程、题库、作业与批改集中管理',
    featureAi: 'AI 辅助教学',
    featureAiDescription: '智能问答、材料处理与学习支持',
    featureOrganization: '组织与权限管理',
    featureOrganizationDescription: '适配学校、教师、学生与家长协作',
    copyright: '© 2026 Perceptio · 为教育机构打造',
    studentsAlt: '庆祝毕业的大学生',
    programmeHeadline: '架起通往世界名校的\n黄金桥梁',
    programmeTagline: '英才汇聚，陆载万物——让世界名校触手可及',
    programmeDescription:
      '致力于通过创新、严谨且公平的资格认证，赋能全球学习者，为他们开启高等教育、职业生涯与个人成长的大门。',
  },
} as const

type Widen<Value> = Value extends string
  ? string
  : { readonly [Key in keyof Value]: Widen<Value[Key]> }
export type AuthTranslations = Widen<typeof authZhCN>
